import React, {Fragment, useMemo, useRef} from 'react';
import './linkMenu.css';
import ButtonMenu from "../buttonMenu/buttonMenu";
import ButtonUser from "../buttonUser/buttonUser";
import {useIntl} from "react-intl";
import auth from "../../../utils/authentication";
import {getCachedImageUrl, isMobileDevice} from "../../../utils/utils";
import {useSelector} from "react-redux";
import group from "../../group";
import users, {LoginHome} from "../../users";
import logo from "../../../images/logos/squadDisk.png";
import {Link} from "react-router-dom";
import UseUserPreferences from '../../user-app-config/hooks/use-user-preferences';

const activeFirulais = false;

const LinkMenu = ({isOpen, toggleContextualMenu}) => {
    const intl = useIntl();

    const verified = auth.currentUser?.emailVerified;
    const userGroups = useSelector(group.selectors.userGroups);
    const loginHome = useRef();
    const darkMode = useSelector(users.selectors.isDarkMode);
    const config = useSelector(users.selectors.getUserConfiguration);
    const {userPreferences} = UseUserPreferences();

    function scrollHomeTo0() {
        const scrollContainer = document.getElementById('home__scrollContainer');
        scrollContainer.scrollTo({top: 0});

    }

    const selectedOptionsNmb = useMemo(() => {
        return userPreferences.barButtons.length;
    }, [userPreferences]);

    if (isMobileDevice()) {
        function closeContextualMenu() {
            if (isOpen) {
                toggleContextualMenu();
            }
        }

        const width = 100 / selectedOptionsNmb + '%';

        const mobileOptions = !auth.currentUser ? {} : {
            squadflix: <ButtonMenu key="squadflix" route="/squadflix" className="m-0" style={{width}}
                                   classIcon={"fa-solid fa-clapperboard"}
                                   onClick={closeContextualMenu}
                                   verified></ButtonMenu>,
            "squadflix-live": <ButtonMenu key="squadflix-live" route="/squadflix/live" className="m-0" style={{width}}
                                          classIcon={"fa-solid fa-tower-broadcast"}
                                          onClick={closeContextualMenu}
                                          verified></ButtonMenu>,
            "squadflix-search": <ButtonMenu key="squadflix-search" route="/squadflix/search-tmdb" className="m-0"
                                            style={{width}}
                                            classIcon={"fa-solid fa-magnifying-glass"}
                                            onClick={closeContextualMenu}
                                            verified></ButtonMenu>,
            drive: <ButtonMenu key="drive" classIcon={"fa-solid fa-hard-drive"}
                               text={intl.formatMessage({id: `app.my-drive`})}
                               route={'/my-drive'} className="m-0" style={{width}} verified={verified}
                               onClick={closeContextualMenu}/>,
            home: <ButtonMenu key="home" text={intl.formatMessage({id: `app.home`})}
                              route={'/home'} className="m-0" style={{width}} verified={auth.currentUser}
                              classIcon={"fa-solid fa-home"}
                              onClick={() => {
                                  closeContextualMenu();
                                  scrollHomeTo0();
                              }}/>,
            groups:
                <ButtonMenu key="groups" classIcon={"fa-solid fa-people-group"}
                            text={intl.formatMessage({id: `app.group`})}
                            onClick={closeContextualMenu} style={{width}}
                            route={'/groups'} className="m-0" alert={!!userGroups?.groupInvites?.length}
                            verified={auth.currentUser}/>,
            firulais: activeFirulais &&
                <ButtonMenu key="firulais" classIcon={"fa-solid fa-dog"} route="/chatbot" text="Firulais AI"
                            className="m-0" style={{width}}
                            onClick={closeContextualMenu}
                            verified={auth.currentUser}></ButtonMenu>,
            "profile-info": <ButtonMenu key="profile-info"
                                        customIcon={<img src={getCachedImageUrl(auth.currentUser.photoURL)}
                                                         style={{
                                                             aspectRatio: "1/1",
                                                             borderRadius: "18px",
                                                             objectFit: "cover",
                                                             objectPosition: "center",
                                                             border: `1px solid ${darkMode ? "rgb(248,249,250)" : "rgb(33,37,41)"}`
                                                         }} height="36px"
                                                         alt="logo"/>}
                                        text="Mi perfil" route={'/my-profile/posts'} className="m-0" style={{width}}
                                        verified={auth.currentUser}
                                        onClick={closeContextualMenu}/>,
        }

        return (
            <div className="col-12 d-flex flex-row linkMenu__borderPhone">
                {auth.currentUser && <Fragment>
                    {userPreferences.barButtons.sort((a, b) => a.order - b.order).map((button) => mobileOptions[button.id])}
                </Fragment>}
                {!auth.currentUser &&
                    <div className="col-12 d-flex flex-row justify-content-around">
                        <ButtonMenu text={intl.formatMessage({id: "users.login.sign-up"})}
                                    classIcon={"fa-solid fa-user-plus"}
                                    verified={true} className="mb-4"
                                    onClick={() => loginHome.current.openModal("signUp")}/>
                        <ButtonMenu text={intl.formatMessage({id: "users.login.log-in"})}
                                    classIcon="fa-solid fa-right-to-bracket"
                                    verified={true} className="mb-4" onClick={() => loginHome.current.openModal()}/>
                    </div>

                }
                <LoginHome ref={loginHome}/>
            </div>
        );
    }

    return (
        <div className="col-12 d-flex flex-row justify-content-end"
             style={{maxHeight: window.innerHeight, height: '100%'}}>
            <div className="col-12 d-flex align-items-end flex-column ">
                <Link className="col-12 d-flex align-items-center mb-4" to={"/home"}>
                    <img src={logo} width="100%" className="App-logo" alt="logo"/>
                </Link>
                <ButtonMenu text={intl.formatMessage({id: `app.home`})} classIcon={"fa-solid fa-house"}
                            route={'/home'} className="mb-4 col-12" verified={auth.currentUser}
                            onClick={scrollHomeTo0}/>
                <ButtonMenu route="/squadflix" text={intl.formatMessage({id: "app.squad-flix"})} className="mb-4 col-12"
                            customIcon={<i className="fa-solid fa-clapperboard pe-3"></i>}
                            verified={auth.currentUser}></ButtonMenu>
                <ButtonMenu classIcon={"fa-solid fa-hard-drive"} text={intl.formatMessage({id: `app.my-drive`})}
                            route={'/my-drive'} className="mb-4 col-12" verified={auth.currentUser}/>
                {activeFirulais && <ButtonMenu route="/chatbot" text="Firulais AI" className="mb-4 col-12"
                                               customIcon={<i className="fa-solid fa-dog pe-3"></i>}
                                               verified={auth.currentUser}></ButtonMenu>}

                <div className="col-12 mt-auto">
                    <ButtonUser className={"col-12 mb-4"}/>
                </div>
            </div>

        </div>
    );
};

export default LinkMenu;
